import { UISref } from "@uirouter/react";
import styled from "styled-components";
import { PrimaryButton } from "../../../../components/button";
import { VerificationService } from "../../../../store/verification/service";
import { FraudRoutes } from "../../routes";

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  & > *:not(:last-child) {
    margin-right: 1em;
  }
`;

export const WidgetAdornment = () => (
  <ButtonWrapper>
    <PrimaryButton
      variant="outlined"
      icon="export"
      onClick={() => VerificationService.downloadKybCsv()}
    >
      Export to CSV
    </PrimaryButton>
    <UISref to={FraudRoutes.names.newBusinessKyb}>
      <a>
        <PrimaryButton icon="plus">New Report</PrimaryButton>
      </a>
    </UISref>
  </ButtonWrapper>
);
